var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 33.666 44.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5889",
    "data-name": "Group 5889",
    transform: "translate(-89.493 -37.108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19264",
    "data-name": "Path 19264",
    d: "M106.927,67.616h-3.582A4.053,4.053,0,0,1,99.3,63.567V53.751a4.053,4.053,0,0,1,4.049-4.049H116.2a4.053,4.053,0,0,1,4.048,4.049V55.5a.787.787,0,0,0,1.573,0V53.751a5.63,5.63,0,0,0-4.317-5.467V44.558a7.45,7.45,0,0,0-14.9,0V48.18a5.632,5.632,0,0,0-4.824,4.783H95.357V50.871a2.814,2.814,0,1,0-1.573,0v2.878a.787.787,0,0,0,.787.787h3.153v3.337H95.009a2.814,2.814,0,1,0,0,1.572h2.715v3.337H94.571a.787.787,0,0,0-.787.787v2.878a2.814,2.814,0,1,0,1.573,0V64.356H97.78a5.629,5.629,0,0,0,5.565,4.833h3.582a.787.787,0,0,0,0-1.573Zm3.127-28.934a5.883,5.883,0,0,1,5.877,5.877v3.571H104.177V44.558a5.883,5.883,0,0,1,5.877-5.877ZM93.33,48.169a1.241,1.241,0,1,1,1.241,1.241A1.243,1.243,0,0,1,93.33,48.169ZM92.307,59.9a1.241,1.241,0,1,1,1.241-1.241A1.243,1.243,0,0,1,92.307,59.9Zm3.505,9.249a1.241,1.241,0,1,1-1.241-1.241A1.243,1.243,0,0,1,95.812,69.149Z",
    fill: "#212832"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19265",
    "data-name": "Path 19265",
    d: "M282.085,235.1a2.438,2.438,0,0,0-2.435,2.435v5.559a2.436,2.436,0,0,0-3.252,1.811,2.427,2.427,0,0,0-3.252,1.649,2.436,2.436,0,0,0-1-.192,2.475,2.475,0,0,0-2.39,2.489v5.214a4.93,4.93,0,0,0,4.924,4.924H279.6a4.93,4.93,0,0,0,4.924-4.924v-16.53a2.438,2.438,0,0,0-2.435-2.435Zm.862,18.965a3.355,3.355,0,0,1-3.351,3.351h-4.912a3.355,3.355,0,0,1-3.351-3.351v-5.214a.9.9,0,0,1,.845-.916h.016a.862.862,0,0,1,.862.862.787.787,0,0,0,1.573,0v-1.576a.9.9,0,0,1,.845-.916.862.862,0,0,1,.878.862.787.787,0,0,0,1.573,0v-1.795a.862.862,0,1,1,1.724,0,.787.787,0,1,0,1.573,0v-7.836a.862.862,0,0,1,1.724,0Z",
    transform: "translate(-161.362 -177.228)",
    fill: "#212832"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19266",
    "data-name": "Path 19266",
    d: "M252.152,195.066a2.175,2.175,0,0,0,2.173-2.173v-3.275a3.913,3.913,0,1,0-4.345,0v3.275A2.175,2.175,0,0,0,252.152,195.066Zm-2.34-8.7a2.34,2.34,0,1,1,3.377,2.1.787.787,0,0,0-.437.7v3.728a.6.6,0,1,1-1.2,0v-3.728a.787.787,0,0,0-.437-.7A2.328,2.328,0,0,1,249.812,186.362Z",
    transform: "translate(-142.098 -130.098)",
    fill: "#212832"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureAccess);
export default __webpack_public_path__ + "static/media/SecureAccess.90986dd624059aa8a317a6624002def3.svg";
export { ForwardRef as ReactComponent };